import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  HostSubSection,
  MostFrequestModel,
  UserModel,
} from "@/database";
import { UserListAction } from "./user.action";

const initialState = {
  userList: {
    list: [] as Array<UserModel>,
    count: 0,
    isLoading: true,
    error: "",
  },
  userBunchList: {
    list: [] as Array<UserModel>,
    count: 0,
    isLoading: true,
    error: "",
  },
  logoutStatus: {
    isLoading: false,
    error: null as string | null,
  },
  currentUser: null as UserModel | null,
  users: [] as UserModel[],
  singleCurrentUser: null as UserModel | null,
  mostFrequentUsers: {
    list: [] as Array<UserModel>,
    count: 0,
    isLoading: false,
    error: "",
  },

  mostFrequentEditor: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentScriptWriter: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentAnchor: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentCameraman: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentContentType: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentCategory: {
    list: [] as Array<MostFrequestModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentSocial: {
    list: [] as Array<UserModel>,
    count: 0,
    isLoading: false,
    error: "",
  },
  mostFrequentDenmark: {
    list: [] as Array<HostSubSection>,
    count: 0,
    isLoading: false,
    error: "",
  },
  user_settings: {
    list: [] as Array<any>,
    count: 0,
    isLoading: false,
    error: "",
  },
  createBucketOrder: null as string[] | null,
};

const UserSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUserList: (state, { payload }: PayloadAction<UserListAction>) => {
      state.userList = {
        ...state.userList,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setUserBunchList: (state, { payload }: PayloadAction<UserListAction>) => {
      state.userBunchList = {
        ...state.userBunchList,
        error: payload?.error ?? state.userBunchList.error,
        list: payload?.data?.list ?? state.userBunchList.list,
        count: payload?.data?.count ?? state.userBunchList.count,
        isLoading: payload?.isLoading ?? state.userBunchList.isLoading,
      };
    },
    setCurrentUser: (state, { payload }: PayloadAction<UserModel | null>) => {
      state.currentUser = payload;
    },
    setSingleCurrentUser: (
      state,
      { payload }: PayloadAction<UserListAction | null>
    ) => {
      state.singleCurrentUser =
        payload?.data?.list[0] ?? state.userList.list[0];
    },
    addUserNew: (state, action) => {
      const user = action.payload;
      state.userList.list = [user, ...state.userList.list];
    },
    setMostFrequentUsers: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentUsers = {
        ...state.mostFrequentUsers,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentEditor: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentEditor = {
        ...state.mostFrequentEditor,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentScriptWriter: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentScriptWriter = {
        ...state.mostFrequentScriptWriter,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentAnchor: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentAnchor = {
        ...state.mostFrequentAnchor,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentCameraman: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentCameraman = {
        ...state.mostFrequentCameraman,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentContentType: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentContentType = {
        ...state.mostFrequentContentType,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setUserSettings: (state, { payload }: PayloadAction<UserListAction>) => {
      state.user_settings = {
        ...state.user_settings,
        error: payload?.error ?? state.user_settings.error,
        list: payload?.data?.list ?? state.user_settings.list,
        count: payload?.data?.count ?? state.user_settings.count,
        isLoading: payload?.isLoading ?? state.user_settings.isLoading,
      };
    },
    setMostFrequentCategory: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentCategory = {
        ...state.mostFrequentCategory,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentSocial: (
      state,
      { payload }: PayloadAction<UserListAction>
    ) => {
      state.mostFrequentSocial = {
        ...state.mostFrequentSocial,
        error: payload?.error ?? state.userList.error,
        list: payload?.data?.list ?? state.userList.list,
        count: payload?.data?.count ?? state.userList.count,
        isLoading: payload?.isLoading ?? state.userList.isLoading,
      };
    },
    setMostFrequentDenmark: (state, { payload }: PayloadAction<any>) => {
      state.mostFrequentDenmark = state.mostFrequentDenmark = {
        ...state.mostFrequentDenmark,
        isLoading: payload?.isLoading ?? state.mostFrequentDenmark.isLoading,
        error: payload?.error ?? state.mostFrequentDenmark.error,
        list: payload?.list ?? state.mostFrequentDenmark.list,
      };
    },
    setLogoutStatus: (
      state,
      { payload }: PayloadAction<{ isLoading: boolean; error: string | null }>
    ) => {
      state.logoutStatus = {
        isLoading: payload.isLoading,
        error: payload.error,
      };
    },
    setCreateBucketOrder: (
      state,
      { payload }: PayloadAction<string[] | null>
    ) => {
      state.createBucketOrder = payload;
    },
  },
});

// creating actions from reducers
export const {
  setUserList,
  setCurrentUser,
  addUserNew,
  setSingleCurrentUser,
  setMostFrequentUsers,
  setMostFrequentEditor,
  setMostFrequentScriptWriter,
  setMostFrequentAnchor,
  setMostFrequentCameraman,
  setMostFrequentContentType,
  setMostFrequentCategory,
  setMostFrequentSocial,
  setMostFrequentDenmark,
  setLogoutStatus,
  setUserSettings,
  setUserBunchList,
  setCreateBucketOrder,
} = UserSlice.actions;

export default UserSlice.reducer;
